export const SEO_CONFIG = {
    pl: {
        home: {
            title:
                "Czorsztynianka - Przystań i atrakcje nad Jeziorem Czorsztyńskim",
            description:
                "Rejsy gondolami, wypożyczalnia rowerów i łodzi elektrycznych oraz domki nad Jeziorem Czorsztyńskim. Czorsztyn i Niedzica.",
            image: "/og/home.jpg",
            imageAlt:
                "Gondola Czorsztynianka na Jeziorze Czorsztyńskim",
            robots: "index, follow, max-image-preview:large",
        },

        cruises: {
            title:
                "Rejsy gondolami po Jeziorze Czorsztyńskim - Czorsztynianka",
            description:
                "Regularne przeprawy między Czorsztynem i Niedzicą, możliwość przewozu rowerów oraz rejsy widokowe po Jeziorze Czorsztyńskim.",
            image: "/og/cruises.jpg",
            imageAlt:
                "Rejs gondolą Czorsztynianka po Jeziorze Czorsztyńskim",
            robots: "index, follow, max-image-preview:large",
        },

        houses: {
            title:
                "Domki nad Jeziorem Czorsztyńskim - Zamkowe Wzgórze",
            description:
                "Domki Zamkowe Wzgórze w Niedzicy, położone nad Jeziorem Czorsztyńskim, w pobliżu zamku, plaży i przystani gondoli.",
            image: "/og/houses.jpg",
            imageAlt:
                "Domki Zamkowe Wzgórze nad Jeziorem Czorsztyńskim",
            robots: "index, follow, max-image-preview:large",
        },

        bikes: {
            title:
                "Wypożyczalnia rowerów w Czorsztynie - Velo Czorsztynianka",
            description:
                "Rowery tradycyjne i elektryczne, sprzęt dla dzieci oraz darmowy przewóz wypożyczonych rowerów gondolą między Czorsztynem i Niedzicą.",
            image: "/og/bikes.jpg",
            imageAlt:
                "Rowery z wypożyczalni Velo Czorsztynianka",
            robots: "index, follow, max-image-preview:large",
        },

        boats: {
            title:
                "Łodzie elektryczne bez patentu - Jezioro Czorsztyńskie",
            description:
                "Wynajem 4-osobowych katamaranów i 8-osobowych łodzi elektrycznych bez patentu. Wyjątkowa oferta nad Jeziorem Czorsztyńskim.",
            image: "/og/boats.jpg",
            imageAlt:
                "Łodzie elektryczne i katamarany na Jeziorze Czorsztyńskim",
            robots: "index, follow, max-image-preview:large",
        },

        privacy: {
            title: "Polityka prywatności - Czorsztynianka",
            description:
                "Informacje dotyczące przetwarzania danych osobowych i plików cookies w serwisie Czorsztynianka.",
            image: "/og/home.jpg",
            imageAlt:
                "Czorsztynianka nad Jeziorem Czorsztyńskim",
            robots: "noindex, follow",
        },
    },

    en: {
        home: {
            title:
                "Czorsztynianka - Attractions at Lake Czorsztyn",
            description:
                "Gondola cruises, bike and electric boat rentals, and lakeside cottages in Czorsztyn and Niedzica.",
            image: "/og/home.jpg",
            imageAlt:
                "Czorsztynianka gondola on Lake Czorsztyn",
            robots: "index, follow, max-image-preview:large",
        },

        cruises: {
            title:
                "Gondola Cruises on Lake Czorsztyn - Czorsztynianka",
            description:
                "Regular crossings between Czorsztyn and Niedzica, bicycle transport and scenic cruises on Lake Czorsztyn.",
            image: "/og/cruises.jpg",
            imageAlt:
                "Czorsztynianka gondola cruise on Lake Czorsztyn",
            robots: "index, follow, max-image-preview:large",
        },

        houses: {
            title:
                "Cottages by Lake Czorsztyn - Zamkowe Wzgórze",
            description:
                "Zamkowe Wzgórze cottages in Niedzica, located by Lake Czorsztyn near the castle, beach and gondola marina.",
            image: "/og/houses.jpg",
            imageAlt:
                "Zamkowe Wzgórze cottages by Lake Czorsztyn",
            robots: "index, follow, max-image-preview:large",
        },

        bikes: {
            title:
                "Bike Rental in Czorsztyn - Velo Czorsztynianka",
            description:
                "Standard and electric bikes, equipment for children and free gondola transport for bikes rented from Velo Czorsztynianka.",
            image: "/og/bikes.jpg",
            imageAlt:
                "Bikes available at Velo Czorsztynianka",
            robots: "index, follow, max-image-preview:large",
        },

        boats: {
            title:
                "Licence-Free Electric Boats - Lake Czorsztyn",
            description:
                "Self-drive rental of 4-person electric catamarans and 8-person electric boats. The only offer of its kind on Lake Czorsztyn.",
            image: "/og/boats.jpg",
            imageAlt:
                "Electric boats and catamarans on Lake Czorsztyn",
            robots: "index, follow, max-image-preview:large",
        },

        privacy: {
            title: "Privacy Policy - Czorsztynianka",
            description:
                "Information about personal data processing and cookies on the Czorsztynianka website.",
            image: "/og/home.jpg",
            imageAlt:
                "Czorsztynianka at Lake Czorsztyn",
            robots: "noindex, follow",
        },
    },
};